import { render, staticRenderFns } from "./IntellectualPropertyDropdown.vue?vue&type=template&id=b9876f7a&"
import script from "./IntellectualPropertyDropdown.vue?vue&type=script&lang=js&"
export * from "./IntellectualPropertyDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports